/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { PreviewEnvironment } from 'app/shared-data/models';
import { defaultLoadableState, LoadableState } from '@opengamma/ui';
import { TenantDetails } from 'app/page-modules/tenant-management/models';

/** Shared Data state definition. */
export interface SharedDataState {
  previewEnvironments: LoadableState<PreviewEnvironment[]>;
  tenants: LoadableState<TenantDetails[]>;
}

/** The initial Shared Data state. */
export const INITIAL_STATE: SharedDataState = {
  previewEnvironments: defaultLoadableState(),
  tenants: defaultLoadableState()
};
